import Item from 'antd/lib/list/Item';
import { useCallback, useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { useHistory } from 'react-router-dom';
import { api } from '../services/api';
import { getSubDomain } from './getSubDomain';
import { useAuth } from './useAuth';

interface IUseFetchProps {
  baseUrl: string;
  isLinkProps?: boolean;
  isArray?: boolean;
  showV1?: boolean;
  endFilter?: string;
}

interface FilterProps {
  key: string;
  content: string;
}

export function useFetch<T = unknown>({
  showV1,
  baseUrl,
  isLinkProps = true,
  isArray = true,
  endFilter = '',
}: IUseFetchProps) {
  const [dataFetch, setDataFetch] = useState<T | undefined>();
  const [isFetching, setIsFetching] = useState(false);
  const [filterLink, setFilterLink] = useState('');

  const [itensPerPage, setItensPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItens, setTotalItens] = useState(0);
  const [status, setStatus] = useState(1);
  const [filters, setFilters] = useState<FilterProps[]>([] as FilterProps[]);
  const [search, setSearch] = useState('');

  const [columnOrdenation, setColumnOrdenation] = useState('');
  const [cityName, setCityName] = useState('');

  function handleChangeCityFilter(citieid: string | number, cityName: string) {
    handleAddFilters({ key: '&cidadeId=', content: citieid.toString() });
    setCityName(cityName);
  }

  const linkFetch =
    status !== undefined
      ? `${baseUrl}?limit=${itensPerPage}&page=${currentPage}&search=${search}&sortBy=${columnOrdenation}${filterLink}&filter.status=$eq:${status}`
      : `${baseUrl}?limit=${itensPerPage}&page=${currentPage}&search=${search}&sortBy=${columnOrdenation}${filterLink}`;

  const search2 = window.location.search;
  const params = new URLSearchParams(search2);
  const idRota = params.get('idRota');
  const idRotatrajeto = params.get('idRotatrajeto');

  const idRotalink = idRota ? `&filter.idRota=$eq:${idRota}` : '';
  const idRotatrajetolink = idRotatrajeto ? `&filter.idRotaTrajeto=$eq:${idRotatrajeto}` : '';

  const fetchAPI = useCallback(async () => {
    let variableFetchLink = linkFetch + idRotalink + idRotatrajetolink + endFilter;

    if (!isLinkProps) {
      variableFetchLink = `${baseUrl}`;
    }

    setIsFetching(true);
    try {
      const url = getSubDomain() + variableFetchLink;
      const { data } = await api.get(showV1 ? '/v1' + url : '' + url);

      if (isArray) {
        setDataFetch(data.data);
        setTotalItens(data.meta.totalItems);
      } else {
        setDataFetch(data);
        setTotalItens(0);
      }

      setIsFetching(false);
    } catch (err) {
      setIsFetching(false);
      console.log(err);
    }
  }, [baseUrl, isArray, isLinkProps, linkFetch]);

  async function refetch() {
    await fetchAPI();
  }

  function ApplyFilters() {
    const res = filters.map(item => {
      return `${item.key}${item.content}`;
    });
    setFilterLink(res.join(''));
  }

  function applyFiltersNow(object: FilterProps) {
    let initialArray = filters;
    let arrayFilter = initialArray.filter(item => item.key !== object.key);
    let finalArray = [...arrayFilter, object];
    const res = finalArray.map(item => {
      return `${item.key}${item.content}`;
    });

    setFilters(finalArray);
    setFilterLink(res.join(''));
  }

  function handleAddFilters(object: FilterProps) {
    let initialArray = filters;
    let arrayFilter = initialArray.filter(item => item.key !== object.key);
    let finalArray = [...arrayFilter, object];
    setFilters(finalArray);
    const res = finalArray.map(item => {
      return `${item.key}${item.content}`;
    });
    setFilterLink(res.join(''));
  }

  function handleAddFiltersWithApplyFilters(object: FilterProps) {
    let initialArray = filters;
    let arrayFilter = initialArray.filter(item => item.key !== object.key);
    let finalArray = [...arrayFilter, object];
    const res = finalArray.map(item => {
      return `${item.key}${item.content}`;
    });

    setFilters(finalArray);
    setFilterLink(res.join(''));
  }

  function clearFilters() {
    setFilters([]);
    setFilterLink('');
    setCityName('');
  }

  const [cookies] = useCookies(['whats-front-token']);
  const token = cookies['whats-front-token'];

  useEffect(() => {
    if (token) {
      api.defaults.headers.common.authorization = `Bearer ${token}`;
      fetchAPI();
    }
  }, [fetchAPI, token]);

  useEffect(() => {
    if (token) fetchAPI();
  }, [linkFetch, filters]);

  /*  useEffect(() => {
    if (activeCity) fetchAPI();
  }, [activeCity]); */

  return {
    dataFetch,
    cityName,
    isFetching,
    currentPage,
    setCurrentPage,
    clearFilters,
    itensPerPage,
    setItensPerPage,
    totalItens,
    filters,
    handleAddFilters,
    search,
    setSearch,
    setStatus,
    applyFiltersNow,
    columnOrdenation,
    setColumnOrdenation,
    refetch,
    handleChangeCityFilter,
    ApplyFilters,
    handleAddFiltersWithApplyFilters,
  };
}
